import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_AC_PACKAGED_UNIT',
  GET: 'GET_AC_PACKAGED_UNIT',
  CREATE: 'CREATE_AC_PACKAGED_UNIT',
  EDIT: 'EDIT_AC_PACKAGED_UNIT',
  DELETE: 'DELETE_AC_PACKAGED_UNIT',
  DUPLICATE: 'DUPLICATE_AC_PACKAGED_UNIT',
  CLEAR_ERROR: 'CLEAR_ERROR_AC_PACKAGED_UNIT',
  ADD_AC_PACKAGED_SUB: 'ADD_AC_PACKAGED_SUB_TO_AC_PACKAGED',
  EDIT_AC_PACKAGED_SUB: 'EDIT_AC_PACKAGED_SUB_TO_AC_PACKAGED',
  REMOVE_AC_PACKAGED_SUB: 'REMOVE_AC_PACKAGED_SUB_TO_AC_PACKAGED',
};

export const clearErrorACPackagedUnit = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchACPackagedUnitByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = 10;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchACPackagedUnit(pageSize, page, sorted, filtered, isPublic, excludeZoneId);
};

const searchACPackagedUnit = (pageSize, page, sorted, filtered, isPublic, excludeZoneId = null) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_AC_PACKAGED_UNIT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listACPackagedUnit = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchACPackagedUnit(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getACPackagedUnit = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_AC_PACKAGED_UNIT}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createACPackagedUnit = (name, typeId, brandId, SEER, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('type', typeId);
  formData.set('brand_id', brandId);
  formData.set('cooling_capacity', coolingCap);
  formData.set('unit', unitId);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acpu_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_PACKAGED_UNIT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editACPackagedUnit = (id, name, typeId, brandId, SEER, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (typeId) formData.set('type', typeId);
  if (brandId) formData.set('brand_id', brandId);
  if (coolingCap) formData.set('cooling_capacity', coolingCap);
  if (unitId) formData.set('unit', unitId);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acpu_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_PACKAGED_UNIT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteACPackagedUnit = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_PACKAGED_UNIT}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateACPackagedUnit = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_AC_PACKAGED_UNIT}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const addACPackagedPackagedSub = (acPackagedId, packagedSubId, quantity) => {
  const data = {
    packaged_id: acPackagedId,
    packaged_sub_id: packagedSubId,
    quantity: quantity,
  };

  return {
    type: ACTION.ADD_AC_PACKAGED_SUB,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_PACKAGED_PACKAGED_SUB,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editACPackagedPackagedSub = (acPackagedPackagedSubId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT_AC_PACKAGED_SUB,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_PACKAGED_PACKAGED_SUB}${acPackagedPackagedSubId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeACPackagedPackagedSub = (acPackagedPackagedSubId, packagedId) => {
  return {
    type: ACTION.REMOVE_AC_PACKAGED_SUB,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_PACKAGED_PACKAGED_SUB}${acPackagedPackagedSubId}/`,
    })
      .then(() => ({ id: acPackagedPackagedSubId, packaged_id: packagedId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_packaged_unit/ac_packaged_unit_actions.js